import todo from '../../images/javascript/todo.png'
import StickyNavbar from '../../images/javascript/sticky-navbar.png'
import ExchangeRateCalculator from '../../images/javascript/exchange-rate.jpg'
import FormValidator from '../../images/javascript/form-validator.png'
import SliderModal from '../../images/javascript/slider-modal.jpg'
import Accordion from '../../images/javascript/accordion.jpg'
const items = [
  {
    id: 1,
    title: "Todo App",
    category: "Projects",
    img: todo,
    desc: `Todo Javascript App`,
    urlLink: "https://igor-javascript-todo.netlify.app/",
  },
  {
    id: 2,
    title: "Sticky Navbar",
    category: "Navbars",
    img: StickyNavbar,
    desc: `Javascript Sticky Navbar App`,
    urlLink: "https://igor-javascript-sticky-navbar.netlify.app/",
  },
  {
    id: 3,
    title: "Exchange Rate",
    category: "Projects",
    img: ExchangeRateCalculator,
    desc: `Exchange Rate Calculator`,
    urlLink: "https://igor-javascript-exchange-rate.netlify.app/",
  },
  {
    id: 4,
    title: "Form Validator",
    category: "Forms",
    img: FormValidator,
    desc: `Validation for form`,
    urlLink: "https://igor-javascript-form-validator.netlify.app/",
  },
  {
    id: 5,
    title: "Slider & Modal",
    category: "Modal",
    img: SliderModal,
    desc: `Slider with Modal elements`,
    urlLink: "https://igor-javascript-slider-modal.netlify.app/",
  },

  {
    id: 6,
    title: "Accordion",
    category: "Accordions",
    img: Accordion,
    desc: `Accordion basic element`,
    urlLink: "https://igor-javascript-accordion.netlify.app/",
  },
  
]

export default items
